import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteField,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../services/firebase";
import { queryClient } from "../queries/queryClient";
import { CACHE_TIME } from "../queries/cachePolicy";



const updatedColors = async (body) => {
  const categoryRef = doc(firestore, "customization", "colors");
  const data = await setDoc(categoryRef, body, { merge: true });
  return data;
};

const updatedFonts = async (body) => {
  const categoryRef = doc(firestore, "customization", "fonts");
  const data = await setDoc(categoryRef, body, { merge: true });

  return data;
};

const theme = async (docId) => {
  const docRef = doc(firestore, "customization", docId);
  const docSnap = await getDoc(docRef);

  const data = { id: docSnap.id, ...docSnap.data() };

  return data;
};

const updatedCustomizationInfo = async (body) => {
  const categoryRef = doc(firestore, "customization", "infos");
  const data = await setDoc(categoryRef, body, { merge: true });

  return data;
};

const customImages = async (fileType) => {
  const docRef = doc(
    firestore,
    "customization",
    fileType.includes("font") ? "fonts" : "images"
  );
  const docSnap = await getDoc(docRef);

  const imageData = { id: docSnap.id, ...docSnap.data() };

  if (fileType === 'imageAppMobile') {
        // retorna apenas a urlMobile dentro de imageApp
        const url = imageData.imageApp?.urlMobile || null;
        return url ? { url } : null;
      }
  // caso padrão: devolve o objeto do campo fileType
  return imageData[fileType] || null;
};

const deleteFont = async (fontType) => {
  const docRef = doc(firestore, "customization", "fonts");

  await updateDoc(docRef, { [fontType]: deleteField() });
};

//QUERIES
export const useGetTheme = (docId) => {
  return useQuery({
    queryKey: [docId],
    queryFn: () => theme(docId),
    // SEM o prazo longo de BRAND de propósito: as telas de personalização
    // (EditMain, Brand, CustomLogin) gravam de volta, ao abrir, o que leram
    // daqui. Com 1 h de cache, um valor velho sobrescrevia a edição feita
    // em outra aba/aparelho. São ~3 leituras por sessão — não compensa.
  });
};

export const useCustomImages = (fileType) => {
  return useQuery({
    queryKey: ["IMAGE", fileType],
    queryFn: () => customImages(fileType),
    staleTime: CACHE_TIME.BRAND,
  });
};

//MUTATIONS
export const useUpdatedColors = () => {
  return useMutation({
    mutationFn: (data) => updatedColors(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["colors"],
      });
    },
    onError: (err) => {
      console.log(`Unsuccessful returned error ${err}`);
    },
  });
};

export const useUpdatedFonts = () => {
  return useMutation({
    mutationFn: (data) => updatedFonts(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["fonts"],
      });
    },
    onError: (err) => {
      console.log(`Unsuccessful returned error ${err}`);
    },
  });
};

export const useUpdatedCustomizationInfo = () => {
  return useMutation({
    mutationFn: (data) => updatedCustomizationInfo(data),
    onSuccess: () => {
      // A query dos textos é criada por `useGetTheme("infos")`, cuja key é
      // ["infos"] — a key antiga (["customization", "infos"]) nunca casava, então
      // o cache não era invalidado e título/subtítulo só apareciam na Main depois
      // de recarregar a página. As cores/fontes sempre funcionaram porque já
      // invalidam ["colors"]/["fonts"].
      queryClient.invalidateQueries({ queryKey: ["infos"] });
    },
    onError: (err) => console.log(`Erro ao salvar infos: ${err}`),
  });
};
export const useDeleteFont = (fontType) => {
  return useMutation({
    mutationFn: () => deleteFont(fontType),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["fonts"],
      });
    },
    onError: (err) => {
      console.log(`Unsuccessful returned error ${err}`);
    },
  });
};
